import { Card } from '@tribeplatform/react-ui-kit/Card'

export const WhatsNew = () => (
  <div className="max-w-3xl h-screen m-auto flex flex-col space-y-3">
    <h3>What&apos;s new</h3>
    <Card className="overflow-hidden flex-grow">
      <iframe
        title="What's new"
        className="h-full p-3 bg-[#fbf9f7]"
        src="https://community.tribe.so/embed/space/whats-new?readonly=false&header=false&composer=false&about=false"
      ></iframe>
    </Card>
  </div>
)
